









































































import Vue from "vue";
import { Component, Ref } from "vue-property-decorator";
// @ts-ignore
import Password from "vue-password-strength-meter";
import IResetPasswordModel from "@/interfaces/reset-password-model";

@Component({
  components: {
    Password,
  },
})
export default class ResetPassword extends Vue {
  checkPassword(rule: any, value: any, callback: any) {
    if (!value) {
      return callback(new Error("A password is required"));
    } else {
      if (this.passwordScore < 3) {
        return callback(new Error("A stronger password is required."));
      }

      return callback();
    }
  }

  checkPasswordMatch(rule: any, value: any, callback: any) {
    if (value === "") {
      return callback(new Error("A new password is required"));
    } else {
      if (this.passwordScore < 3) {
        return callback(new Error("A stronger password is required."));
      }

      if (this.passwordForm.passwordConfirmation !== "") {
        this.passwordFormRef.validateField("passwordConfirmation");
      }

      return callback();
    }
  }

  checkPasswordMatch1(rule: any, value: any, callback: any) {
    if (value === "") {
      return callback(new Error("Please re-type your new password"));
    } else if (value !== this.passwordForm.password) {
      return callback(new Error("The passwords do not match"));
    } else {
      return callback();
    }
  }

  loading = false;
  success = false;
  failed = false;
  userId = "";
  code = "";
  passwordScore = 0;

  rules: any = {
    password: [
      {
        validator: this.checkPasswordMatch,
        required: true,
        trigger: "blur",
      },
    ],
    passwordConfirmation: [
      {
        validator: this.checkPasswordMatch1,
        required: true,
        trigger: "change",
      },
    ],
  };

  passwordForm: any = {
    password: "",
    passwordConfirmation: "",
  };

  @Ref("passwordFormRef")
  passwordFormRef!: any;

  @Ref("newPasswordInput")
  newPasswordInput!: any;

  mounted() {
    if (
      this.$route.params &&
      this.$route.query.code &&
      this.$route.params.userId
    ) {
      this.code = this.$route.query.code as string;
      this.userId = this.$route.params.userId;
      this.newPasswordInput.focus();
    } else {
      this.failed = true;
    }
  }

  //
  // Used for validation
  setPasswordScore(score: number) {
    this.passwordScore = score;
  }

  retry() {
    this.loading = false;
    this.success = false;
    this.failed = false;
  }

  submitPassword() {
    this.passwordFormRef.validate((valid: boolean) => {
      if (valid && this.code && this.userId) {
        this.loading = true;
        this.success = false;
        this.failed = false;

        const model: IResetPasswordModel = {
          newPassword: this.passwordForm.password,
          code: this.code,
          userId: this.userId,
        };

        this.$store.dispatch("authentication/resetPassword", model).then(
          () => {
            this.loading = false;
            this.success = true;
          },
          () => {
            this.loading = false;
            this.failed = true;
          }
        );
      }
    });
  }
}
